(function() {
    'use strict';

    angular
        .module('jmsApp')
        .config(configFunc)
        .run(runFunc);
    function runFunc($q, $rootScope,Path) {
        $rootScope.initPortalLoader = $q.defer();
        angular.element('.no-js-wrapper').remove();
        Path.init('/api/admin/jms/structure/', '/api');
        $rootScope.initPortalLoader.resolve();
    }
    function configFunc(RmsEnumProvider) {
        RmsEnumProvider.changePath('/api/v1/app/form/enum/getEnum/');
    }
})();